import { SystemStyleObject } from '@chakra-ui/react';
import {
  ColorMode,
  getBorderWidthToken,
} from '@allergan-data-labs/alle-elements-core';

export const getIconWrapperStyles = (
  isInteractive?: boolean,
  colorMode: ColorMode = 'light',
  hasHoverIcon = false,
  isActive = false
): SystemStyleObject => {
  const svgStyles = {
    outlineStyle: 'solid',
    borderRadius: 'Circle',
    border: 'none',
    outlineWidth: 0,
    outlineOffset: '-3px',
  };
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24',
    height: '24',
    cursor: isInteractive ? 'pointer' : 'default',
    svg: {
      color: `${colorMode}.Icon/Neutral/Interactive/Enable`,
    },
    _hover: {
      svg: {
        ...svgStyles,
        ...(!isActive &&
          !hasHoverIcon &&
          isInteractive && {
            color: `${colorMode}.Icon/Neutral/Interactive/Hover`,
          }),
      },
    },
    _focusVisible: {
      borderColor: 'transparent',
      outline: 'none',
      svg: {
        ...svgStyles,
        outlineWidth: getBorderWidthToken('Bold'),
        outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
      },
    },
  };
};
